// src/hooks/useProcessedContent.ts
import {Translate} from "@components/Theme/Translate/Translate"
import Truncate from "@hooks/Truncate"
import parse from "html-react-parser"
import {ReactNode, useMemo} from "react"

export interface ProcessOptions {
	stripHtml?: boolean
	translate?: boolean
	truncate?: number
}

const useProcessedContent = (
	raw: string | ReactNode | undefined,
	opts: ProcessOptions,
): ReactNode | undefined => {
	const {stripHtml = false, translate = false, truncate} = opts

	return useMemo(() => {
		if (raw == null) return undefined
		if (typeof raw !== "string") return raw

		let text = raw

		if (stripHtml) {
			text = text.replace(/<\/?(?:p|h[1-6])[^>]*?>/gim, "")
			text = text.replace(/<[^>]+>|&[^;]+;/g, (m) =>
				m === "&amp;" ? "&" : "",
			)
		}

		if (truncate && truncate > 0) {
			const maybe = Truncate(text, truncate)
			if (typeof maybe === "string") text = maybe
		}

		const parsed = stripHtml ? text : parse(text)

		if (translate && typeof parsed === "string") {
			return <Translate>{parsed}</Translate>
		}

		return parsed
	}, [raw, stripHtml, translate, truncate])
}

export default useProcessedContent
